var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeCard3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.98 96.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.9,64.39A29.64,29.64,0,1,1,66,31.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "54.97 39.51 46.58 47.79 54.97 56.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.91 39.51 71.3 47.79 62.91 56.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.99,
    y1: 60.44,
    x2: 13.86,
    y2: 65.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.14,
    y1: 8.94,
    x2: 55.14,
    y2: 13.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.7,66.48A36.4,36.4,0,0,1,1.5,45.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.32,5.12A36.41,36.41,0,0,1,73.48,35.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.64,78.32v0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 36.6,
    cy: 85.31,
    rx: 12.59,
    ry: 2.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.2,91.69c0,1.57-5.64,2.85-12.6,2.85S24,93.26,24,91.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.88,
    y1: 91.6,
    x2: 23.88,
    y2: 85.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.23,
    y1: 91.36,
    x2: 49.23,
    y2: 85.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.54,23.76c-4.89,0,0,9-6,9h0c6.46,0,1.84,8.7,5.95,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.62,23.76c4.89,0,0,9,6,9h0c-6.46,0-1.84,8.7-6,8.7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCard3);
export default __webpack_public_path__ + "static/media/homeCard3.379b0fb2db818cc3588e785d41244e2c.svg";
export { ForwardRef as ReactComponent };